module.exports = {"542430100":"尼玛镇","542430200":"文部乡","542430201":"中仓乡","542430202":"卓瓦乡","542430203":"卓尼乡","542430204":"吉瓦乡","542430205":"甲谷乡","542430206":"阿索乡","542430207":"俄久乡","542430208":"荣玛乡","542430209":"达果乡","542430210":"申亚乡","542430211":"来多乡","542430212":"军仓乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542430.json
// module id = 2560
// module chunks = 0